import axios from 'axios';
import config from '../../config';
import { apiCode, apiConfig } from '../../services';
import { setUserPreferences } from '../user';

export const UI_TOGGLE_EXPLORE_ASIDE = 'UI_TOGGLE_EXPLORE_ASIDE';
export const UI_TOGGLE_FILTER_ASIDE = 'UI_TOGGLE_FILTER_ASIDE';
export const UI_SET_ASIDE_FILTERS = 'UI_SET_ASIDE_FILTERS';
export const UI_SET_ASIDE_FILTER_VALUE = 'UI_SET_ASIDE_FILTER_VALUE';
export const UI_CLEAR_ASIDE_FILTER_VALUES = 'UI_CLEAR_ASIDE_FILTER_VALUES';
export const UI_SET_PICKER_FILTERS = 'UI_SET_PICKER_FILTERS';
export const UI_SET_PICKER_FILTER_VALUE = 'UI_SET_PICKER_FILTER_VALUE';
export const UI_CLEAR_PICKER_FILTER_VALUES = 'UI_CLEAR_PICKER_FILTER_VALUES';
export const UI_TOGGLE_LEFT_ASIDE = 'UI_TOGGLE_LEFT_ASIDE';
export const UI_TOGGLE_RIGHT_ASIDE = 'UI_TOGGLE_RIGHT_ASIDE';
export const UI_TOGGLE_LEFT_ASIDE_MENU = 'UI_TOGGLE_LEFT_ASIDE_MENU';
export const UI_TOGGLE_RIGHT_ASIDE_PANEL = 'UI_TOGGLE_RIGHT_ASIDE_PANEL';
export const UI_CLEAR = 'UI_CLEAR';
export const UI_SAVING = 'UI_SAVING';
export const UI_TAGS_LOADED = 'UI_TAGS_LOADED';
export const UI_TEXT_LOADED = 'UI_TEXT_LOADED';
export const UI_HANDLES_LOADED = 'UI_HANDLES_LOADED';
export const UI_ADD_IMAGE = 'UI_ADD_IMAGE';
export const UI_CLEAR_IMAGE = 'UI_CLEAR_IMAGE';
export const UI_GOALS_UPDATED = 'UI_GOALS_UPDATED';
export const UI_CUSTOM_TEXT_LOADED = 'UI_CUSTOM_TEXT_LOADED';
export const UI_VIDEO = 'UI_VIDEO';
export const UI_ENABLED = 'UI_ENABLED';
export const UI_HAS_CRM_METRICS = 'UI_HAS_CRM_METRICS';
export const UI_TEAM_PAGE = 'UI_TEAM_PAGE';
export const UI_VIDEO_TIME = 'UI_VIDEO_TIME';
export const UI_SET_FORM_HELP = 'UI_SET_FORM_HELP';
export const UI_SET_DASHBOARD_LOCKED = 'UI_SET_DASHBOARD_LOCKED';
export const UI_SHOW_SUCCESS = 'UI_SHOW_SUCCESS';
export const UI_WIDGET_CONFIG = 'UI_WIDGET_CONFIG';
export const UI_SET_MODAL_PICKER_SHOW_CLEAR = 'UI_SET_MODAL_PICKER_SHOW_CLEAR';
export const UI_SET_MODAL_PICKER_SHOW_CLEAR_COUNT = 'UI_SET_MODAL_PICKER_SHOW_CLEAR_COUNT';

export const setModalPickerShowClear = payload => {
    return { type: UI_SET_MODAL_PICKER_SHOW_CLEAR, payload };
};

export const setModalPickerShowClearCount = payload => {
    return { type: UI_SET_MODAL_PICKER_SHOW_CLEAR_COUNT, payload };
};

export const toggleExploreAside = payload => {
    return { type: UI_TOGGLE_EXPLORE_ASIDE, payload };
};

export const toggleFilterAside = payload => {
    return { type: UI_TOGGLE_FILTER_ASIDE, payload };
};

export const setAsideFilters = payload => {
    return { type: UI_SET_ASIDE_FILTERS, payload };
};

export const setAsideFilterValue = payload => {
    return { type: UI_SET_ASIDE_FILTER_VALUE, payload };
};

export const clearAsideFilterValues = () => {
    return { type: UI_CLEAR_ASIDE_FILTER_VALUES };
};

export const setPickerFilters = payload => {
    return { type: UI_SET_PICKER_FILTERS, payload };
};

export const setPickerFilterValue = payload => {
    return { type: UI_SET_PICKER_FILTER_VALUE, payload };
};

export const clearPickerFilterValues = () => {
    return { type: UI_CLEAR_PICKER_FILTER_VALUES };
};

export const showWidgetConfig = payload => {
    return { type: UI_WIDGET_CONFIG, payload };
};

export const setShowSuccess = payload => {
    return { type: UI_SHOW_SUCCESS, payload };
};

export const setFormHelp = payload => {
    return { type: UI_SET_FORM_HELP, payload };
};

export const setDashboardLocked = payload => {
    return { type: UI_SET_DASHBOARD_LOCKED, payload };
};

export const setVideoTime = payload => {
    return { type: UI_VIDEO_TIME, payload };
};

export const setTeamPage = payload => {
    return { type: UI_TEAM_PAGE, payload };
};

export const setLeftAside = open => {
    return { type: UI_TOGGLE_LEFT_ASIDE, payload: open };
};

export const toggleLeftAside = () => {
    return (dispatch, getState) => {
        const { guid, preferences } = getState().user.user;
        const { leftAsideOpen } = getState().ui;
        let prefObj = preferences ? JSON.parse(preferences) : { leftAsideOpen: true };
        prefObj = { ...prefObj, leftAsideOpen: !leftAsideOpen };
        const prefJson = JSON.stringify(prefObj);

        return axios
            .patch(`${config.apiGateway.URL}preferences${apiCode(true)}`, { preferences: prefJson }, apiConfig(guid))
            .then(response => {
                dispatch(setLeftAside(!leftAsideOpen));
                dispatch(setUserPreferences(prefJson));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const toggleRightAside = () => {
    return { type: UI_TOGGLE_RIGHT_ASIDE };
};

export const setSaving = payload => {
    return { type: UI_SAVING, payload };
};

export const setEnabled = payload => {
    return { type: UI_ENABLED, payload };
};

export const setVideoPosition = payload => {
    return { type: UI_VIDEO, payload };
};

export const setRightAsidePanel = payload => {
    return { type: UI_TOGGLE_RIGHT_ASIDE_PANEL, payload };
};

export const toggleLeftAsideMenu = payload => {
    return { type: UI_TOGGLE_LEFT_ASIDE_MENU, payload };
};

export const handlesLoaded = payload => {
    return { type: UI_HANDLES_LOADED, payload };
};

export const goalsUpdated = () => {
    return { type: UI_GOALS_UPDATED };
};

export const tagsLoaded = payload => {
    return { type: UI_TAGS_LOADED, payload };
};

export const textLoaded = payload => {
    return { type: UI_TEXT_LOADED, payload };
};

export const customTextLoaded = payload => {
    return { type: UI_CUSTOM_TEXT_LOADED, payload };
};

export const imageLoaded = payload => {
    return { type: UI_ADD_IMAGE, payload };
};

export const clearUI = payload => {
    return { type: UI_CLEAR, payload };
};

export const clearImage = (folder, file) => {
    return { type: UI_CLEAR_IMAGE, payload: { folder, file } };
};

export const loadHandles = () => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}handles${apiCode(true)}`, apiConfig(guid))
            .then(response => {
                dispatch(handlesLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const loadTags = () => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}tag${apiCode(true)}`, apiConfig(guid))
            .then(response => {
                dispatch(tagsLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const loadText = () => {
    return (dispatch, getState) => {
        const { guid, language_Id } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}ui/system-text/${language_Id}${apiCode(true)}`, apiConfig(guid))
            .then(response => {
                dispatch(textLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const toggleFormHelp = () => {
    return (dispatch, getState) => {
        const { guid, preferences } = getState().user.user;
        const { showFormHelp } = getState().ui;
        let prefObj = preferences ? JSON.parse(preferences) : { showFormHelp: true };
        prefObj = { ...prefObj, showFormHelp: !showFormHelp };
        const prefJson = JSON.stringify(prefObj);

        return axios
            .patch(`${config.apiGateway.URL}preferences${apiCode(true)}`, { preferences: prefJson }, apiConfig(guid))
            .then(response => {
                dispatch(setFormHelp(!showFormHelp));
                dispatch(setUserPreferences(prefJson));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const toggleDashboardLock = () => {
    return (dispatch, getState) => {
        const { guid, preferences } = getState().user.user;
        const { dashboardLocked } = getState().ui;
        let prefObj = preferences ? JSON.parse(preferences) : { dashboardLocked: false };
        prefObj = { ...prefObj, dashboardLocked: !dashboardLocked };
        const prefJson = JSON.stringify(prefObj);

        return axios
            .patch(`${config.apiGateway.URL}preferences${apiCode(true)}`, { preferences: prefJson }, apiConfig(guid))
            .then(response => {
                dispatch(setDashboardLocked(!dashboardLocked));
                dispatch(setUserPreferences(prefJson));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const loadCustomText = () => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}ui/custom-text${apiCode(true)}`, apiConfig(guid))
            .then(response => {
                dispatch(customTextLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const pageViewed = view => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        axios.post(`${config.apiGateway.URL}view${apiCode(true)}`, view, apiConfig(guid));
    };
};

export const addImage = (folder, file, partnerId = 0) => {
    return (dispatch, getState) => {
        const key = `${folder}-${file}-${partnerId}`;

        let downloading = [];
        try {
            downloading = e4_global.downloading;
        } catch {
            // Do Nothing - without catch tests fail with 'e4_global is not defined'
        }

        if (!downloading.some(d => d === key)) {
            downloading.push(key);
            const { guid } = getState().user?.user;
            const { images } = getState().ui;

            if (images.filter(i => i.folder === folder && i.file === file).length === 0) {
                return axios
                    .get(
                        `${config.apiGateway.URL}download/${folder}/${file}/${partnerId || 0}${apiCode()}`,
                        apiConfig(guid, null, true)
                    )
                    .then(response => {
                        const src = `data:image/jpg;base64,${response.data}`;
                        dispatch(imageLoaded({ folder, file, src }));
                    })
                    .catch(err => {
                        // console.log(err);
                    });
            }
        }
    };
};
